import { LazyQueryHookOptions, useLazyQuery } from '@apollo/client';
import { Article, ArticleOrderByInput, ArticleWhereInput } from 't2-graphql-types';
import { getPostsQuery } from '../queries/getPostsQuery';

type TVariables = {
  where: ArticleWhereInput;
  skip?: number;
  take?: number;
  orderBy?: [ArticleOrderByInput];
};

type TData = {
  articles: Article[];
};

export const useLazyPostsQuery = (options: LazyQueryHookOptions<TData, TVariables> = {}) =>
  useLazyQuery<TData, TVariables>(getPostsQuery, {
    fetchPolicy: 'network-only',
    ...options,
  });
